import { cn } from '@/utils';
import { ArrowSeparator } from './SimulationProgressNavIcons';
import { SimulationProgressNavStep } from '../types';

/**
 * Component to render the label for each step in the SimulationProgressNav.
 * It displays the step label and an arrow separator (if it's not the last step).
 */
export const SimulationProgressNavStepLabel: React.FC<{
  index: number;
  label: string;
  status: SimulationProgressNavStep['status'];
  showSeparator: boolean;
}> = ({ label, index, showSeparator, status = 'upcoming' }) => {
  // ================================
  // Compute derived state
  // ================================
  const isCompleted = status === 'completed';
  const isActive = status === 'active';
  const isUpcoming = status === 'upcoming';

  /**
   * Class names for the step label based on its status:
   * - Active step: black text
   * - Completed or upcoming steps: gray text
   */
  const labelClassNames = cn(
    'pointer-events-none whitespace-nowrap',
    'font-text text-sm font-regular leading-none',
    {
      'text-neutral-black': isActive,
      'text-neutral-gray-700': isCompleted || isUpcoming,
    },
  );

  // ================================
  // Render component
  // ================================
  return (
    <div className="pointer-events-none flex items-center gap-2">
      <span className={labelClassNames}>{label}</span>
      {showSeparator && <ArrowSeparator className="shrink-0" index={index} />}
    </div>
  );
};

SimulationProgressNavStepLabel.displayName = 'SimulationProgressNavStepLabel';

export default SimulationProgressNavStepLabel;
